module.exports = __webpack_public_path__ + "static/media/irishdistillers.e64acc6a.png";